import { render, staticRenderFns } from "./RulePage.vue?vue&type=template&id=9bd3cd52&"
import script from "./RulePage.vue?vue&type=script&lang=js&"
export * from "./RulePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports